import styled from 'styled-components';
import {
  NavLink,
} from 'react-router-dom';

export const Tab = styled(NavLink).attrs({
  activeClassName: 'selected',
})`
  color: #9ea0a1;
  font-size: 18px;
  line-height: 44px;
  text-transform: capitalize;
  border-bottom: 2px solid transparent;
  padding: 2px 0px;
  cursor: pointer;
  position: relative;

  &.selected {
    color: ${props => props.theme.colors.primary};
    border-bottom-color: ${props => props.theme.colors.primary};
  }
`;

export const Unread = styled.span`
  width: 5px;
  height: 5px;
  border-radius: 50%;
  position: absolute;
  top: 23px;
  right: -6px;
  background-color: ${props => props.theme.colors.primary};
`;
